import React from 'react';
import { Button, Form, FormInstance, Input, Modal } from 'antd';
import { rules } from 'common/helpers/form.helper';
import { ReactComponent as ProfileIcon } from 'app/assets/images/profile.svg';
import { AuthCard } from 'entities/Auth/components/AuthCard';
import { ICreateAccountPayload } from 'entities/Account/Account.models';

interface IComponentProps {
  open: boolean;
  form: FormInstance;
  loading: boolean;
  error: string | null;
  isEdit: boolean;
  onSubmit: (values: ICreateAccountPayload) => void;
  onCancelClick: () => void;
}

export const CreateAccountModal: React.FC<IComponentProps> = (props) => {
  const { open, form, loading, error, isEdit, onSubmit, onCancelClick } = props;

  return (
    <Modal className="create-account-modal" open={open} footer={false} closeIcon={false}>
      <AuthCard
        form={form}
        loading={loading}
        body={
          <>
            <Form.Item name="name" rules={[rules.required()]}>
              <Input placeholder="Введите название компании" />
            </Form.Item>

            <Form.Item label="Владелец аккаунта" name="email" rules={[rules.type('email', 'Неверный формат электронной почты')]}>
              <Input placeholder="Введите адрес электронной почты" prefix={<ProfileIcon />} disabled={isEdit} />
            </Form.Item>

            <Form.Item name="firstName" rules={[rules.required()]}>
              <Input placeholder="Введите имя владельца" prefix={<ProfileIcon />} disabled={isEdit} />
            </Form.Item>

            <Form.Item name="lastName" rules={[rules.required()]}>
              <Input placeholder="Введите фамилию владельца" prefix={<ProfileIcon />} disabled={isEdit} />
            </Form.Item>

            {!!error && (
              <div className="auth-card__error-block">
                <span className="auth-card__error-block-item">{error}</span>
              </div>
            )}
          </>
        }
        footer={
          <>
            <Button className="btn btn-default" onClick={onCancelClick}>
              Отмена
            </Button>

            <Button className="btn btn-primary" htmlType="submit">
              {isEdit ? 'Редактировать' : 'Создать'}
            </Button>
          </>
        }
        onSubmit={onSubmit}
      />
    </Modal>
  );
};
